import {
  INSERT_CHECK_LIST_COMMAND,
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  ListType,
} from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { LexicalCommand } from 'lexical';
import { FC, useCallback, useMemo } from 'react';
import { useSelectedListNode } from '../../hooks';
import { $removeSelectedListItems } from '../../utils';
import { ToolbarButton, ToolbarButtonProps } from './ToolbarButton';

type ListButtonProps = ToolbarButtonProps & {
  listType: ListType;
};

export const ListButton: FC<ListButtonProps> = ({ listType, children, ...rest }) => {
  const [editor] = useLexicalComposerContext();

  const [listNode] = useSelectedListNode();
  const isActive = useMemo(() => editor.read(() => listNode?.getListType()) === listType, [editor, listNode, listType]);

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      if (isActive) {
        // only the selected items are converted, REMOVE_LIST_COMMAND would convert the whole list
        editor.update(() => {
          $removeSelectedListItems();
        });
      } else {
        let command: LexicalCommand<void>;
        switch (listType) {
          case 'bullet':
            command = INSERT_UNORDERED_LIST_COMMAND;
            break;
          case 'check':
            command = INSERT_CHECK_LIST_COMMAND;
            break;
          case 'number':
            command = INSERT_ORDERED_LIST_COMMAND;
            break;
        }
        editor.dispatchCommand(command, undefined);
      }
    },
    [editor, isActive, listType]
  );

  return (
    <ToolbarButton onClick={handleClick} isActive={isActive} {...rest}>
      {children}
    </ToolbarButton>
  );
};
